import './../../shop/modules/services.tcat_seven_eleven';
import './../../shop/modules/services.family-mart-freeze';
import './../../shop/modules/services.family-mart';
import './../../shop/modules/services.seven-eleven';
import './../../shop/modules/multi_checkout/services.multi-checkout';
import './../../shop/modules/services.sfexpress';
import './../../shop/modules/services.sl_logistics_yto';
import './../../shop/modules/services.browser';
import './../../shop/modules/services.yup-helper';
import './../../shop/modules/services.feature';
import { isEmpty, cloneDeep, pick, omit } from 'lodash-es';
import { CHECKOUT_EVENTS } from '../../shop/constants/angular-events';
import loggerService from '../../utils/loggerService';
import {
  DESTINATION_TYPES,
  TCAT_711PICKUP_DESTINATION_TYPES,
} from './constants/destinationType';
import { CART_SECTION, scrollToSection } from './utils/cart-scroll.helper';
import {
  COLLAPSE_STATUS,
  SECTION_STATUS,
} from '../../shop/constants/components/collapse-section-status';
import {
  getSubmitZeek,
  getSubmitAddress,
  getSubmitSfLocker,
  getSubmitMarketPickUp,
  getSubmitStorePickUp,
  parseSevenData,
  parseFamilyData,
  parseFamilyFrozenData,
  sortCartsByTags,
  checkSkipDestination,
  selectedDeliveriesFilter,
  checkSkipDestinationWithOption,
  STORE_CALLBACK_TYPES,
} from './utils/common';
import {
  sfExpressSchema,
  sfPlusSchema,
  zeekSchema,
  marketPickUpSchema,
} from './yupSchemas/common';
import {
  CART_STEPS,
  BUTTON_STATUS,
  NEXT_STEP_EVENT_TYPE,
} from './constants/multi-checkout';

const DESTINATION_TYPES_FORM_DATA_MAPPING = {
  [DESTINATION_TYPES.TW_TCAT_711PICKUP_ROOMTEMP_EMAP_ONLY]:
    'twTcat711pickupRoomtempEmapOnly',
  [DESTINATION_TYPES.TW_TCAT_711PICKUP_REFRIGERATED_EMAP_ONLY]:
    'twTcat711PickupRefrigeratedEmapOnly',
  [DESTINATION_TYPES.TW_TCAT_711PICKUP_FROZEN_EMAP_ONLY]:
    'twTcat711PickupFrozenEmapOnly',
  [DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_ROOMTEMP]:
    'slLogisticsTcat711PickupRoomtemp',
  [DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_REFRIGERATED]:
    'slLogisticsTcat711PickupRefrigerated',
  [DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_FROZEN]:
    'slLogisticsTcat711PickupFrozen',
};

const DYNAMIC_SHIPPING_COUNTRIES = ['TW', 'TH', 'MY', 'VN', 'HK'];

const CALCULATE_FEE_WITHOUT_AREA_PLATFORMS = [
  'tw_ezship',
  'tw_711_nopay',
  'tw_711_pay',
  'tw_711_b2c_nopay',
  'tw_711_b2c_pay',
  '711_return_nopay',
  'tw_fm_b2c_nopay',
  'tw_fm_b2c_pay',
  'tw_fm_c2c_nopay',
  'tw_fm_c2c_pay',
  'sl_logistics_fmt_freeze_pay',
  'sl_logistics_fmt_freeze_nopay',
  'sl_logistics_yto_store',
  'sl_logistics_yto_store_cod',
  'sl_logistics_yto_special_store',
  'sl_logistics_yto_special_store_cod',
];

const DEFAULT_ERRORS = {
  sevenEleven: {},
  familyMart: {},
  familyMartFrozen: {},
  sfExpress: {},
  sfPlus: {},
};

const getInitState = () => ({
  // api data
  destinations: [],
  displayDestinations: [],

  // ui status
  buttonStatus: BUTTON_STATUS.DISABLED,
  sectionStatus: SECTION_STATUS.DEFAULT,
  collapseStatus: COLLAPSE_STATUS.COLLAPSED,
  isLoading: false,
  isFieldBlocked: true,
  sectionError: '',
  shouldHideDestinationSection: false,

  // form data
  formData: {
    address: {},
    sevenEleven: {},
    familyMart: {},
    familyMartFrozen: {},
    storePickupData: {},
    sfExpress: {},
    sfPlus: {},
    zeek: {},
  },

  // form status
  errors: cloneDeep(DEFAULT_ERRORS),
  // Scope of zeek directive is not isolated.
  zeekErrors: {},
  zeekPickupStatus: {},
  addressModuleOptions: {
    validateBeforeSubmit: false,
  },
});

app.directive('destinationSection', [
  '$q',
  'mainConfig',
  '$filter',
  'yupHelper',
  'browserService',
  'slLogisticsYtoService',
  'sfexpressService',
  'multiCheckoutService',
  'sevenElevenService',
  'familyMartService',
  'familyMartFreezeService',
  'featureService',
  'tcatSevenElevenService',
  function (
    $q,
    mainConfig,
    $filter,
    yupHelper,
    browserService,
    slLogisticsYtoService,
    sfexpressService,
    multiCheckoutService,
    sevenElevenService,
    familyMartService,
    familyMartFreezeService,
    featureService,
    tcatSevenElevenService,
  ) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.html'),
      scope: {
        currentStep: '=',
        hasItemError: '&',
      },
      link: function (scope, element) {
        let isSkipDestinationTrackerEventTriggered = false;
        // init state
        Object.assign(scope, getInitState());
        scope.DESTINATION_TYPES_FORM_DATA_MAPPING =
          DESTINATION_TYPES_FORM_DATA_MAPPING;

        function getCartDestination() {
          scope.isLoading = true;
          scope.buttonStatus = BUTTON_STATUS.DISABLED;
          multiCheckoutService
            .getCartDestination()
            .then(
              ({
                country,
                cart_tags: cartTags,
                deliveries: destinations,
                user_addresses: userAddresses,
                delivery_options: deliveryOptions,
                user_stores: userStores,
              }) => {
                if (scope.cartCountry !== country) {
                  scope.formData.address = {};
                }
                scope.cartCountry = country;
                scope.destinations =
                  sortCartsByTags(cartTags, destinations) || {};
                scope.userAddresses = userAddresses || [];
                scope.userStores = userStores || {
                  seven_eleven: [],
                  family_mart: [],
                };

                const selectedDeliveryOptions = selectedDeliveriesFilter(
                  scope.destinations,
                  deliveryOptions,
                );
                scope.deliveryOptions = selectedDeliveryOptions || [];
                applyAndCleanUpFormData(
                  scope.destinations,
                  selectedDeliveryOptions,
                );
                scope.displayDestinations = transformApiDestinationsToDisplay(
                  selectedDeliveryOptions,
                );
                multiCheckoutService.setDestinations(scope.displayDestinations);

                if (scope.sectionStatus !== SECTION_STATUS.DEFAULT) {
                  scope.buttonStatus = BUTTON_STATUS.ENABLED;
                }

                scope.sectionError = '';
                scope.shouldHideDestinationSection = checkSkipDestination(
                  scope.deliveryOptions,
                );
                handleCallbackAction(destinations);
              },
            )
            .catch((error) => {
              scope.sectionError = error.message;
              scope.sectionStatus = SECTION_STATUS.ERROR;
              scope.buttonStatus = BUTTON_STATUS.DISABLED;
            })
            .finally(() => {
              scope.isLoading = false;
            });
        }

        scope.$parent.$on(CHECKOUT_EVENTS.CART.DESTINATION.RELOAD, function () {
          getCartDestination();
        });

        scope.$parent.$on(
          CHECKOUT_EVENTS.CART.STEP.NEXT,
          function (_, { nextStep, actionType }) {
            if (nextStep === CART_STEPS.DESTINATION) {
              scope.collapseStatus = COLLAPSE_STATUS.EXPANDED;
              scope.sectionStatus = SECTION_STATUS.ACTIVE;
              scope.buttonStatus = BUTTON_STATUS.ENABLED;
              scope.isFieldBlocked = false;

              scrollToSection(CART_SECTION.DESTINATION);
            }

            if (nextStep !== CART_STEPS.DESTINATION) {
              scope.sectionStatus = SECTION_STATUS.DEFAULT;
              scope.buttonStatus = BUTTON_STATUS.DISABLED;
              scope.isFieldBlocked = true;

              if (actionType === NEXT_STEP_EVENT_TYPE.NEXT) {
                scope.collapseStatus = COLLAPSE_STATUS.COLLAPSED;
              }
            }

            scope.addressModuleOptions = { validateBeforeSubmit: false };
            scope.errors = cloneDeep(DEFAULT_ERRORS);
          },
        );

        function handleSkipDestinationTrackerEvent() {
          if (isSkipDestinationTrackerEventTriggered) return;

          const skipDestinationTypeExists = scope.displayDestinations.find(
            (destination) =>
              destination.blockType === DESTINATION_TYPES.SKIP_DESTINATION,
          );

          if (skipDestinationTypeExists) {
            multiCheckoutService.trackFillRecipientData(
              DESTINATION_TYPES.SKIP_DESTINATION,
            );
            isSkipDestinationTrackerEventTriggered = true;
          }
        }

        scope.$watch('currentStep', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }

          // it would be directive goto summary step if all destinations are `skip_destination`
          if ([CART_STEPS.DESTINATION, CART_STEPS.SUMMARY].includes(newVal)) {
            handleSkipDestinationTrackerEvent();
          }
          if (newVal === CART_STEPS.SUMMARY) {
            isSkipDestinationTrackerEventTriggered = false;
          }
        });

        scope.onZeekLocationChange = (deliveryData) => {
          if (!isEmpty(deliveryData)) {
            scope.formData.zeek = deliveryData;
          }
        };
        const supportedDynamicFeeCountries = featureService.hasFeature(
          'dynamic_shipping_rate_refactor_jp',
        )
          ? [...DYNAMIC_SHIPPING_COUNTRIES, 'JP']
          : DYNAMIC_SHIPPING_COUNTRIES;

        function isDynamicFeeCountry() {
          return supportedDynamicFeeCountries.includes(scope.cartCountry);
        }

        function checkSkipRegionType(option) {
          const skipPlatForm = CALCULATE_FEE_WITHOUT_AREA_PLATFORMS.includes(
            option.region_type,
          );
          const skip711CrossCountry =
            option.region_type === 'cross_border_711_store_pick_up' &&
            scope.cartCountry !== 'MY';
          const skipCustom =
            option.region_type === 'custom' &&
            !option.requires_customer_address;

          return !skipPlatForm && !skip711CrossCountry && !skipCustom;
        }

        function checkDeliveryArea(option) {
          if (option.fee_type === 'sl_logistic') {
            return true;
          }

          const hasNoDeliveryAreaMatchCountry = option.delivery_rates.some(
            (rate) => {
              const hasMatchCountry = rate.countries.includes(
                scope.cartCountry,
              );
              const hasCountryCodeArea = rate.delivery_areas?.includes(
                scope.cartCountry,
              );
              const hasDeliveryArea = rate.delivery_areas?.length > 0;
              return hasMatchCountry && !hasCountryCodeArea && hasDeliveryArea;
            },
          );
          return (
            featureService.hasFeature('dynamic_shipping_rate_refactor') &&
            hasNoDeliveryAreaMatchCountry
          );
        }

        function isDynamicFeeIncludedInArea() {
          return scope.deliveryOptions?.some((option) => {
            return checkSkipRegionType(option) && checkDeliveryArea(option);
          });
        }

        scope.showDynamicDeliveryFeeHint = () => {
          return isDynamicFeeCountry() && isDynamicFeeIncludedInArea();
        };

        function getSubmitPayload(type, destination, deliveryOption) {
          switch (type) {
            case DESTINATION_TYPES.ADDRESS:
            case DESTINATION_TYPES.SAVE_ADDRESS:
              return getSubmitAddress(
                { ...scope.formData.address, country_code: scope.cartCountry },
                destination,
              );
            case DESTINATION_TYPES.SAVE_STORE_MAP_7_11:
            case DESTINATION_TYPES.STORE_MAP_7_11:
              return getSubmitMarketPickUp(
                scope.formData.sevenEleven,
                destination,
              );
            case DESTINATION_TYPES.SAVE_STORE_MAP_FAMILY_MART:
            case DESTINATION_TYPES.STORE_MAP_FAMILY_MART:
              return getSubmitMarketPickUp(
                scope.formData.familyMart,
                destination,
              );
            case DESTINATION_TYPES.STORE_MAP_FAMILY_MART_FROZEN:
              return getSubmitMarketPickUp(
                scope.formData.familyMartFrozen,
                destination,
              );
            case DESTINATION_TYPES.STORE_PICK_UP:
              return getSubmitStorePickUp(
                scope.formData.storePickupData,
                destination.delivery_option_id,
                destination,
              );
            case DESTINATION_TYPES.SF_EXPRESS_LOCKER:
              return getSubmitSfLocker(
                scope.formData.sfExpress,
                deliveryOption.config_data?.sfexpress_type,
                destination,
              );
            case DESTINATION_TYPES.SF_PLUS_LOCKER:
              return getSubmitSfLocker(
                scope.formData.sfPlus,
                deliveryOption.config_data?.sfexpress_type,
                destination,
              );
            case DESTINATION_TYPES.ZEEK:
              return getSubmitZeek(scope.formData.zeek, destination);
            case DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_ROOMTEMP:
            case DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_REFRIGERATED:
            case DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_FROZEN:
            case DESTINATION_TYPES.TW_TCAT_711PICKUP_ROOMTEMP_EMAP_ONLY:
            case DESTINATION_TYPES.TW_TCAT_711PICKUP_REFRIGERATED_EMAP_ONLY:
            case DESTINATION_TYPES.TW_TCAT_711PICKUP_FROZEN_EMAP_ONLY: {
              const formDataKey = DESTINATION_TYPES_FORM_DATA_MAPPING[type];

              return getSubmitMarketPickUp(
                scope.formData[formDataKey],
                destination,
              );
            }
            default:
              return destination;
          }
        }

        function generateUpdateDestinationPayload() {
          const payload = Object.entries(scope.destinations).reduce(
            (submitData, [cartTagId, destination]) => {
              const deliveryOption = scope.deliveryOptions.find(
                (option) => option._id === destination.delivery_option_id,
              );
              const type = getDestinationType(deliveryOption);
              const submitPayload = getSubmitPayload(
                type,
                destination,
                deliveryOption,
              );

              return {
                ...submitData,
                [cartTagId]: omit(submitPayload, 'payment_id'),
              };
            },
            {},
          );
          return payload;
        }

        scope.validateForm = function () {
          scope.addressModuleOptions = { validateBeforeSubmit: true };
          const isZeekValid = scope.validateZeek();
          const isSFPlusValid = scope.validateSFPlus();
          const isSFExpressValid = scope.validateSFExpress();
          const isStorePickUpValid = scope.validateStorePickUp();
          const isSevenElevenValid = scope.validSevenElevenMap();
          const isFamilyMartValid = scope.validFamilyMartMap();
          const isFamilyMartFrozenValid = scope.validFamilyMartFrozenMap();
          const isTcatSevenElevenValid = scope.validTcatSevenElevenMap();
          const isSavedStoreSevenElevenValid =
            scope.validSavedStoreSevenElevenMap();
          const isSavedStoreFamilyMartValid =
            scope.validSavedStoreFamilyMartMap();

          return $q((resolve) => {
            setTimeout(() => {
              resolve(element.find('.has-error').length === 0);
            });
          }).then((isAddressValid) => {
            return (
              isAddressValid &&
              isZeekValid &&
              isSFPlusValid &&
              isSFExpressValid &&
              isStorePickUpValid &&
              isSevenElevenValid &&
              isFamilyMartValid &&
              isFamilyMartFrozenValid &&
              isTcatSevenElevenValid &&
              isSavedStoreSevenElevenValid &&
              isSavedStoreFamilyMartValid
            );
          });
        };

        scope.onNextStepClick = function () {
          scope.validateForm().then((isValid) => {
            if (!isValid) {
              scope.sectionStatus = SECTION_STATUS.ERROR;
              scope.buttonStatus = BUTTON_STATUS.DISABLED;
              return;
            }
            scope.submitCartDestination();
          });
        };

        scope.updateDestination = () => {
          const payload = generateUpdateDestinationPayload();
          return multiCheckoutService.updateCartDestination({
            deliveries: payload,
          });
        };

        scope.combineNames = function (nameTranslations) {
          const names = nameTranslations.map((deliveryName) => {
            return $filter('translateModel')(deliveryName);
          });
          return Array.from(new Set(names));
        };

        scope.submitCartDestination = function () {
          scope.$emit(CHECKOUT_EVENTS.CART.DESTINATION.CHANGING);
          scope.isLoading = true;
          scope.panelStatus = SECTION_STATUS.ACTIVE;
          scope.buttonStatus = BUTTON_STATUS.DISABLED;
          scope
            .updateDestination()
            .then(() => {
              scope.collapseStatus = COLLAPSE_STATUS.COLLAPSED;
              scope.sectionStatus = SECTION_STATUS.DEFAULT;
              scope.sectionError = '';
              // notify other sections
              scope.$parent.$broadcast(CHECKOUT_EVENTS.CART.STEP.NEXT, {
                nextStep: CART_STEPS.SUMMARY,
                actionType: NEXT_STEP_EVENT_TYPE.NEXT,
              });
              scrollToSection(CART_SECTION.SUMMARY, {
                scrollDirectly: !browserService.isPad(),
              });
            })
            .catch((error) => {
              scope.sectionError = error.message;
              scope.sectionStatus = SECTION_STATUS.ERROR;
              scope.buttonStatus = BUTTON_STATUS.DISABLED;
            })
            .finally(() => {
              scope.isLoading = false;
              scope.$emit(CHECKOUT_EVENTS.CART.DESTINATION.CHANGED);
            });
        };

        function focusDestination() {
          scope.$parent.$broadcast(CHECKOUT_EVENTS.CART.STEP.NEXT, {
            nextStep: CART_STEPS.DESTINATION,
            actionType: NEXT_STEP_EVENT_TYPE.FOCUS,
          });
        }

        scope.$on('ngRepeatFinished', function () {
          const form = element.find('#multi-checkout__destination__form');
          form.on('input', () => {
            scope.buttonStatus = BUTTON_STATUS.ENABLED;
            if (scope.sectionStatus === SECTION_STATUS.DEFAULT) {
              focusDestination();
            }
          });
          form.find('input[type=checkbox]').on('change', function () {
            scope.buttonStatus = BUTTON_STATUS.ENABLED;
            if (scope.sectionStatus === SECTION_STATUS.DEFAULT) {
              focusDestination();
            }
          });
          form.find('input[type=radio]').on('change', function () {
            scope.buttonStatus = BUTTON_STATUS.ENABLED;
            if (scope.sectionStatus === SECTION_STATUS.DEFAULT) {
              focusDestination();
            }
          });
        });

        function handleCallbackAction(deliveries) {
          const isCallback = Object.values(deliveries).some((delivery) =>
            Object.values(STORE_CALLBACK_TYPES).includes(
              delivery.delivery_data?.action,
            ),
          );

          if (isCallback && scope.sectionStatus === SECTION_STATUS.DEFAULT) {
            scope.updateDestination().then(() => {
              focusDestination();
            });
          }
        }

        function isYTOStoreDelivery(deliveryOption) {
          const supportedAddressType =
            deliveryOption?.config?.supported_address_type || [];

          return (
            slLogisticsYtoService.storeDeliveryKeys.includes(
              deliveryOption?.region_type,
            ) ||
            (deliveryOption?.config?.company_code === 'YTO' &&
              supportedAddressType.includes('STORE_STREET'))
          );
        }

        function getDestinationType(option) {
          const {
            region_type: regionType,
            requires_customer_address: requiresCustomerAddress,
            config_data: configData,
          } = option;

          const showAddress =
            requiresCustomerAddress &&
            regionType !== 'hk_sfplus' &&
            !isYTOStoreDelivery(option);

          const isSevenEleven = sevenElevenService.isSevenEleven(regionType);

          const isFamilyMart = familyMartService.isFamilyMart(regionType);

          const isFamilyMartWithFrozenDelivery =
            familyMartFreezeService.isFreezeType(regionType);

          const isSfExpress = sfexpressService.isSfExpress(option);

          const supportedAddressType = configData?.supported_address_type || [];

          const isZeek =
            configData?.company_code === 'HKZEEK' &&
            supportedAddressType.includes('STORE_STREET');

          if (checkSkipDestinationWithOption(option)) {
            return DESTINATION_TYPES.SKIP_DESTINATION;
          }

          if (showAddress) {
            if (!isEmpty(scope.userAddresses)) {
              return DESTINATION_TYPES.SAVE_ADDRESS;
            }
            return DESTINATION_TYPES.ADDRESS;
          }

          if (isSevenEleven) {
            if (!isEmpty(scope.userStores.seven_eleven)) {
              return DESTINATION_TYPES.SAVE_STORE_MAP_7_11;
            }
            return DESTINATION_TYPES.STORE_MAP_7_11;
          }

          if (isFamilyMart) {
            if (!isEmpty(scope.userStores.family_mart)) {
              return DESTINATION_TYPES.SAVE_STORE_MAP_FAMILY_MART;
            }
            return DESTINATION_TYPES.STORE_MAP_FAMILY_MART;
          }

          if (isFamilyMartWithFrozenDelivery) {
            return DESTINATION_TYPES.STORE_MAP_FAMILY_MART_FROZEN;
          }

          if (isSfExpress) {
            return regionType === 'hk_sfplus'
              ? DESTINATION_TYPES.SF_PLUS_LOCKER
              : DESTINATION_TYPES.SF_EXPRESS_LOCKER;
          }

          if (isZeek) {
            return DESTINATION_TYPES.ZEEK;
          }

          if (
            tcatSevenElevenService.isSlLogisticsTcatSevenElevenRoomtempType(
              regionType,
            )
          ) {
            return DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_ROOMTEMP;
          }

          if (
            tcatSevenElevenService.isSlLogisticsTcatSevenElevenRefrigeratedType(
              regionType,
            )
          ) {
            return DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_REFRIGERATED;
          }

          if (
            tcatSevenElevenService.isSlLogisticsTcatSevenElevenFrozenType(
              regionType,
            )
          ) {
            return DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_FROZEN;
          }

          return regionType;
        }

        function isObjectValuesEmpty(obj) {
          return Object.values(obj).every(isEmpty);
        }

        function applyAndCleanUpFormData(destinations, deliveryOptions) {
          applyFormData(destinations, deliveryOptions);
          cleanUpFormData(destinations, deliveryOptions);
        }

        function applyFormData(destinations, deliveryOptions) {
          Object.values(destinations).forEach((destination) => {
            const deliveryOption = deliveryOptions.find(
              (option) => option._id === destination.delivery_option_id,
            );

            if (isEmpty(deliveryOption)) return;

            const type = getDestinationType(deliveryOption);

            const deliveryData = destination.delivery_data || {};
            const deliveryAddress = destination.delivery_address || {};

            switch (type) {
              case DESTINATION_TYPES.ADDRESS:
              case DESTINATION_TYPES.SAVE_ADDRESS:
                if (!isEmpty(deliveryAddress)) {
                  scope.formData.address = deliveryAddress;
                  break;
                }
                if (isObjectValuesEmpty(scope.formData.address)) {
                  scope.formData.address = {};
                  break;
                }
                break;
              case DESTINATION_TYPES.SAVE_STORE_MAP_7_11:
              case DESTINATION_TYPES.STORE_MAP_7_11:
                if (!isEmpty(deliveryData)) {
                  scope.formData.sevenEleven = parseSevenData(
                    deliveryData,
                    mainConfig,
                  );
                  break;
                }
                if (isObjectValuesEmpty(scope.formData.sevenEleven)) {
                  scope.formData.sevenEleven = {};
                  break;
                }
                break;
              case DESTINATION_TYPES.SAVE_STORE_MAP_FAMILY_MART:
              case DESTINATION_TYPES.STORE_MAP_FAMILY_MART:
                if (!isEmpty(deliveryData)) {
                  scope.formData.familyMart = parseFamilyData(
                    deliveryData,
                    mainConfig,
                  );
                  break;
                }
                if (isObjectValuesEmpty(scope.formData.familyMart)) {
                  scope.formData.familyMart = {};
                  break;
                }
                break;
              case DESTINATION_TYPES.STORE_MAP_FAMILY_MART_FROZEN:
                scope.formData.familyMartFrozen = parseFamilyFrozenData(
                  deliveryData,
                  mainConfig,
                );
                break;
              case DESTINATION_TYPES.SF_PLUS_LOCKER:
                scope.formData.sfPlus[
                  deliveryOption.config_data?.sfexpress_type
                ] = deliveryData;
                break;
              case DESTINATION_TYPES.SF_EXPRESS_LOCKER:
                scope.formData.sfExpress[
                  deliveryOption.config_data?.sfexpress_type
                ] = deliveryData;
                break;
              case DESTINATION_TYPES.STORE_PICK_UP:
                scope.formData.storePickupData[destination.delivery_option_id] =
                  deliveryData;
                break;
              case DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_ROOMTEMP:
              case DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_REFRIGERATED:
              case DESTINATION_TYPES.SL_LOGISTICS_TCAT_711PICKUP_FROZEN:
              case DESTINATION_TYPES.TW_TCAT_711PICKUP_ROOMTEMP_EMAP_ONLY:
              case DESTINATION_TYPES.TW_TCAT_711PICKUP_REFRIGERATED_EMAP_ONLY:
              case DESTINATION_TYPES.TW_TCAT_711PICKUP_FROZEN_EMAP_ONLY: {
                const formDataKey = DESTINATION_TYPES_FORM_DATA_MAPPING[type];

                scope.formData[formDataKey] = parseSevenData(
                  deliveryData,
                  mainConfig,
                );
                break;
              }
              case DESTINATION_TYPES.SKIP_DESTINATION:
                break;
              default:
                loggerService.error(
                  new Error(`Unsupported destinationType: ${type}`),
                  {
                    context: { destinationType: type },
                  },
                );
            }
          });
        }

        function cleanUpFormData(destinations, deliveryOptions) {
          const deliveryOptionIds = Object.values(destinations).map(
            (destination) => destination.delivery_option_id,
          );
          const selectedSfExpressTypesInCart = deliveryOptions
            .filter(({ _id }) => deliveryOptionIds.includes(_id))
            .filter(
              (deliveryOption) =>
                getDestinationType(deliveryOption) ===
                DESTINATION_TYPES.SF_EXPRESS_LOCKER,
            )
            .map((option) => option.config_data.sfexpress_type);

          scope.formData.sfExpress = pick(
            scope.formData.sfExpress,
            selectedSfExpressTypesInCart,
          );
        }

        function getMergeMappingCondition(type, currentOption) {
          const typeMapper = ({ blockType }) => blockType === type;
          const typeMapperWithId = ({ blockType, id }) =>
            blockType === type && id === currentOption._id;
          const slExpressMapper = ({ blockType, option: itemOption }) => {
            const isSameType = blockType === type;
            const isSameExpressType =
              itemOption.config_data?.sfexpress_type ===
              currentOption.config_data?.sfexpress_type;

            return isSameType && isSameExpressType;
          };

          switch (type) {
            case DESTINATION_TYPES.SF_PLUS_LOCKER:
            case DESTINATION_TYPES.SF_EXPRESS_LOCKER:
              return slExpressMapper;
            case DESTINATION_TYPES.STORE_PICK_UP:
              return typeMapperWithId;
            default:
              return typeMapper;
          }
        }

        function transformApiDestinationsToDisplay(deliveryOptions) {
          const displayDestinations = deliveryOptions.reduce(
            (result, option) => {
              const type = getDestinationType(option);
              const mapper = getMergeMappingCondition(type, option);
              const existTypeIndex = result.findIndex(mapper);

              if (existTypeIndex >= 0) {
                const {
                  nameTranslations,
                  cartTagIds = [],
                  combinedIds = [],
                } = result[existTypeIndex];
                const mergedTranslation = [
                  ...nameTranslations,
                  option.name_translations,
                ];

                const mergedCartTagId = [...cartTagIds, option.cartTagId];
                const mergedCombinedIds = [...combinedIds, option._id];

                const newDestination = {
                  ...result[existTypeIndex],
                  option,
                  nameTranslations: mergedTranslation,
                  cartTagIds: mergedCartTagId,
                  combinedIds: mergedCombinedIds,
                };

                result[existTypeIndex] = newDestination;
                return result;
              }

              return [
                ...result,
                {
                  blockType: type,
                  nameTranslations: [option.name_translations],
                  option,
                  id: option._id,
                  cartTagIds: [option.cartTagId],
                  combinedIds: [option._id],
                },
              ];
            },
            [],
          );
          return displayDestinations;
        }

        function shouldBeValidWithType(type) {
          return scope.displayDestinations.some(
            (destination) => destination.blockType === type,
          );
        }

        scope.nextButtonDisabled = function () {
          return scope.buttonStatus === 'disabled' || scope.hasItemError();
        };

        scope.validateZeek = function () {
          const shouldValidate = shouldBeValidWithType(DESTINATION_TYPES.ZEEK);

          if (!shouldValidate) {
            return true;
          }

          const { isValid, errors } = yupHelper.yupValidation(
            zeekSchema,
            scope.zeekPickupStatus,
          );

          scope.zeekErrors = errors;

          return isValid;
        };

        scope.validateSFPlus = function () {
          const shouldValidate = shouldBeValidWithType(
            DESTINATION_TYPES.SF_PLUS_LOCKER,
          );

          if (!shouldValidate) {
            return true;
          }

          const isSfPlusValid = Object.entries(scope.formData.sfPlus).every(
            ([sfexpressType, payload]) => {
              const { isValid, errors } = yupHelper.yupValidation(
                sfPlusSchema,
                payload,
              );
              scope.errors.sfPlus[sfexpressType] = errors;

              return isValid;
            },
          );

          return isSfPlusValid;
        };

        scope.validateSFExpress = function () {
          const shouldValidate = shouldBeValidWithType(
            DESTINATION_TYPES.SF_EXPRESS_LOCKER,
          );

          if (!shouldValidate) {
            return true;
          }

          const isSfExpressValid = Object.entries(
            scope.formData.sfExpress,
          ).every(([sfexpressType, payload]) => {
            const { isValid, errors } = yupHelper.yupValidation(
              sfExpressSchema,
              payload,
            );

            scope.errors.sfExpress[sfexpressType] = errors;

            return isValid;
          });

          return isSfExpressValid;
        };

        scope.validSevenElevenMap = function () {
          const shouldValidate = shouldBeValidWithType(
            DESTINATION_TYPES.STORE_MAP_7_11,
          );

          if (!shouldValidate) {
            return true;
          }

          const { isValid, errors } = yupHelper.yupValidation(
            marketPickUpSchema,
            scope.formData.sevenEleven,
          );

          scope.errors.sevenEleven = errors;
          return isValid;
        };

        scope.validFamilyMartMap = function () {
          const shouldValidate = shouldBeValidWithType(
            DESTINATION_TYPES.STORE_MAP_FAMILY_MART,
          );

          if (!shouldValidate) {
            return true;
          }

          const { isValid, errors } = yupHelper.yupValidation(
            marketPickUpSchema,
            scope.formData.familyMart,
          );

          scope.errors.familyMart = errors;
          return isValid;
        };

        scope.validSavedStoreFamilyMartMap = function () {
          const shouldValidate = shouldBeValidWithType(
            DESTINATION_TYPES.SAVE_STORE_MAP_FAMILY_MART,
          );

          if (!shouldValidate) {
            return true;
          }

          const isNotEmpty = !isEmpty(scope.formData.familyMart);

          if (isNotEmpty) {
            return true;
          }

          const { isValid, errors } = yupHelper.yupValidation(
            marketPickUpSchema,
            scope.formData.familyMart,
          );

          scope.errors.familyMart = errors;
          return isValid;
        };

        scope.validSavedStoreSevenElevenMap = function () {
          const shouldValidate = shouldBeValidWithType(
            DESTINATION_TYPES.SAVE_STORE_MAP_7_11,
          );

          if (!shouldValidate) {
            return true;
          }

          const isNotEmpty = !isEmpty(scope.formData.sevenEleven);

          if (isNotEmpty) {
            return true;
          }

          const { isValid, errors } = yupHelper.yupValidation(
            marketPickUpSchema,
            scope.formData.sevenEleven,
          );

          scope.errors.sevenEleven = errors;
          return isValid;
        };

        scope.validFamilyMartFrozenMap = function () {
          const shouldValidate = shouldBeValidWithType(
            DESTINATION_TYPES.STORE_MAP_FAMILY_MART_FROZEN,
          );

          if (!shouldValidate) {
            return true;
          }

          const { isValid, errors } = yupHelper.yupValidation(
            marketPickUpSchema,
            scope.formData.familyMartFrozen,
          );

          scope.errors.familyMartFrozen = errors;
          return isValid;
        };

        scope.validTcatSevenElevenMap = function () {
          let isAllValid = true;

          Object.values(TCAT_711PICKUP_DESTINATION_TYPES).forEach(
            (destinationType) => {
              const shouldValidate = shouldBeValidWithType(destinationType);

              if (!shouldValidate) {
                return;
              }

              const formDataKey =
                DESTINATION_TYPES_FORM_DATA_MAPPING[destinationType];
              const { isValid, errors } = yupHelper.yupValidation(
                marketPickUpSchema,
                scope.formData[formDataKey],
              );
              scope.errors[formDataKey] = errors;

              if (!isValid) {
                isAllValid = false;
              }
            },
          );

          return isAllValid;
        };

        // store pick up
        scope.onStorePickupSelected = function (
          deliveryData,
          deliveryOptionId,
        ) {
          scope.formData.storePickupData[deliveryOptionId] = deliveryData;
        };

        scope.validateStorePickUp = function () {
          const storePickupDestinations = scope.displayDestinations.filter(
            (destination) =>
              destination.blockType === DESTINATION_TYPES.STORE_PICK_UP,
          );

          if (storePickupDestinations.length === 0) {
            return true;
          }

          let isValid = true;
          storePickupDestinations.forEach((destination) => {
            const id = destination.id;
            if (!scope.formData.storePickupData[id].location_name) {
              scope.formData.storePickupData[id].validateItem = {
                items: [{ code: 'REQUIRED' }],
              };
              isValid = false;
            } else {
              scope.formData.storePickupData[id].validateItem = {
                items: [],
              };
            }
          });
          return isValid;
        };
        // end of store pick up
      },
    };
  },
]);
